import React from 'react';
import { Maybe } from '@css-xp/graphtypes/src/generated-types-new';
import { NoData } from '@css-xp/ppc-common';

interface OrderEmailCellProps {
  email: Maybe<string> | undefined;
}

export const OrderEmailCell = ({ email }: OrderEmailCellProps) => {
  if (!email) {
    return <NoData />;
  } else {
    return <>{email}</>;
  }
};
